export class NeighborStates {
  constructor(public code: string, public neighborCodes: string[]) { }
}

export const NEIGHBORSTATES: Array<NeighborStates> = [
  {
    code: 'AK',
    neighborCodes: [ 'WA' ]
  },
  {
    code: 'AL',
    neighborCodes: [ 'FL', 'GA', 'MS', 'TN' ]
  },
  {
    code: 'AR',
    neighborCodes: [ 'LA', 'MO', 'MS', 'OK', 'TN', 'TX' ]
  },
  {
    code: 'AZ',
    neighborCodes: [ 'CA', 'CO', 'NM', 'NV', 'UT' ]
  },
  {
    code: 'CA',
    neighborCodes: [ 'AZ', 'HI', 'NV', 'OR' ]
  },
  {
    code: 'CO',
    neighborCodes: [ 'AZ', 'KS', 'NE', 'NM', 'OK', 'UT', 'WY' ]
  },
  {
    code: 'CT',
    neighborCodes: [ 'MA', 'NY', 'RI' ]
  },
  {
    code: 'DC',
    neighborCodes: [ 'MD', 'VA' ]
  },
  {
    code: 'DE',
    neighborCodes: [ 'MD', 'NJ', 'PA' ]
  },
  {
    code: 'FL',
    neighborCodes: [ 'AL', 'GA' ]
  },
  {
    code: 'GA',
    neighborCodes: [ 'AL', 'FL', 'NC', 'SC', 'TN' ]
  },
  {
    code: 'HI',
    neighborCodes: [ 'CA' ]
  },
  {
    code: 'IA',
    neighborCodes: [ 'IL', 'MN', 'MO', 'NE', 'SD', 'WI' ]
  },
  {
    code: 'ID',
    neighborCodes: [ 'MT', 'NV', 'OR', 'UT', 'WA', 'WY' ]
  },
  {
    code: 'IL',
    neighborCodes: [ 'IA', 'IN', 'KY', 'MO', 'WI' ]
  },
  {
    code: 'IN',
    neighborCodes: [ 'IL', 'KY', 'MO', 'WI' ]
  },
  {
    code: 'KS',
    neighborCodes: [ 'CO', 'MO', 'NE', 'OK' ]
  },
  {
    code: 'KY',
    neighborCodes: [ 'IL', 'IN', 'MO', 'OH', 'TN', 'VA', 'WV' ]
  },
  {
    code: 'LA',
    neighborCodes: [ 'AR', 'MS', 'TX' ]
  },
  {
    code: 'MA',
    neighborCodes: [ 'CT', 'NH', 'NY', 'RI', 'VT' ]
  },
  {
    code: 'MD',
    neighborCodes: [ 'DC', 'DE', 'PA', 'VA', 'WV' ]
  },
  {
    code: 'ME',
    neighborCodes: [ 'NH' ]
  },
  {
    code: 'MI',
    neighborCodes: [ 'IN', 'OH', 'WI' ]
  },
  {
    code: 'MN',
    neighborCodes: [ 'IA', 'ND', 'SD', 'WI' ]
  },
  {
    code: 'MO',
    neighborCodes: [ 'AR', 'IA', 'IL', 'KS', 'KY', 'NE', 'OK', 'TN' ]
  },
  {
    code: 'MS',
    neighborCodes: [ 'AL', 'AR', 'LA', 'TN' ]
  },
  {
    code: 'MT',
    neighborCodes: [ 'ID', 'ND', 'SD', 'WY' ]
  },
  {
    code: 'NC',
    neighborCodes: [ 'GA', 'SC', 'TN', 'VA' ]
  },
  {
    code: 'ND',
    neighborCodes: [ 'MN', 'MT', 'SD' ]
  },
  {
    code: 'NE',
    neighborCodes: [ 'CO', 'IA', 'KS', 'MO', 'SD', 'WY' ]
  },
  {
    code: 'NH',
    neighborCodes: [ 'MA', 'ME', 'VT' ]
  },
  {
    code: 'NJ',
    neighborCodes: [ 'DE', 'NY', 'PA' ]
  },
  {
    code: 'NM',
    neighborCodes: [ 'AZ', 'CO', 'OK', 'TX', 'UT' ]
  },
  {
    code: 'NV',
    neighborCodes: [ 'AZ', 'CA', 'ID', 'OR', 'UT' ]
  },
  {
    code: 'NY',
    neighborCodes: [ 'CT', 'MA', 'NJ', 'PA', 'VT' ]
  },
  {
    code: 'OH',
    neighborCodes: [ 'IN', 'KY', 'MI', 'PA', 'WV' ]
  },
  {
    code: 'OK',
    neighborCodes: [ 'AR', 'CO', 'KS', 'MO', 'NM', 'TX' ]
  },
  {
    code: 'OR',
    neighborCodes: [ 'CA', 'ID', 'NV', 'WA' ]
  },
  {
    code: 'PA',
    neighborCodes: [ 'DE', 'MD', 'NJ', 'NY', 'OH', 'WV' ]
  },
  {
    code: 'RI',
    neighborCodes: [ 'CT', 'MA' ]
  },
  {
    code: 'SC',
    neighborCodes: [ 'GA', 'NC' ]
  },
  {
    code: 'SD',
    neighborCodes: [ 'IA', 'MN', 'MT', 'ND', 'NE', 'WY' ]
  },
  {
    code: 'TN',
    neighborCodes: [ 'AL', 'AR', 'GA', 'KY', 'MO', 'MS', 'NC', 'VA' ]
  },
  {
    code: 'TX',
    neighborCodes: [ 'AR', 'LA', 'NM', 'OK' ]
  },
  {
    code: 'UT',
    neighborCodes: [ 'AZ', 'CO', 'ID', 'NM', 'NV', 'WY' ]
  },
  {
    code: 'VA',
    neighborCodes: [ 'DC', 'KY', 'MD', 'NC', 'TN', 'WV' ]
  },
  {
    code: 'VT',
    neighborCodes: [ 'MA', 'NH', 'NY' ]
  },
  {
    code: 'WA',
    neighborCodes: [ 'AK', 'ID', 'OR' ]
  },
  {
    code: 'WI',
    neighborCodes: [ 'IA', 'IL', 'MI', 'MN' ]
  },
  {
    code: 'WV',
    neighborCodes: [ 'KY', 'MD', 'OH', 'PA', 'VA' ]
  },
  {
    code: 'WY',
    neighborCodes: [ 'CO', 'ID', 'MT', 'NE', 'SD', 'UT' ]
  }
];

